/* global localData */
document.addEventListener('DOMContentLoaded', () => {
  const guideBannerForm = document.querySelector('form#banner-form');
  if (guideBannerForm) {
    const catalogueSubscribe = (formData) => {
      const formAction = guideBannerForm.querySelector('#action');
      const formNonce = guideBannerForm.querySelector('#nonce');
      const formPosition = guideBannerForm.querySelector('#position');
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, { action: formAction.value }).then((token) => {
          const formDataInput = new FormData();
          formDataInput.append('action', formAction.value);
          formDataInput.append('nonce', formNonce.value);
          formDataInput.append('token', token);
          formDataInput.append('position', formPosition.value);
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('inputs', JSON.stringify(formData));
          axios
            .post(localData.siteURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200) {

                const a = document.createElement('a');
                a.href = response.data.data.url;
                a.download = "meblo";
                a.click();

                guideBannerForm.remove();
                document.querySelector('.guide-banner__form-thankyou').classList.add('is-active');
              }
            })
            .catch((err) => {
              console.error(err);
            });
        });
      });
    };

    const formData = {};
    const fv = FormValidation.formValidation(guideBannerForm, {
      localization: FormValidation.locales.sl_SI,
      fields: {},
      plugins: {
        message: new FormValidation.plugins.Message({
          container: (field, element) => element.closest('.mod-input,.checkbox'),
        }),
        declarative: new FormValidation.plugins.Declarative({
          html5Input: true,
        }),
        trigger: new FormValidation.plugins.Trigger(),
        submitButton: new FormValidation.plugins.SubmitButton(),
      },
    })
      .on('core.element.validated', (e) => {
        // e.element presents the field element
        // e.valid indicates the field is valid or not

        // Get the field value
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(e.element, '.mod-input,.checkbox');
        const validationFailed = !e.valid && value === '';
        FormValidation.utils.classSet(container, { 'is-validation-failed': validationFailed });
        if (!validationFailed) {
          if (container.classList.contains('checkbox')) {
            formData[e.field] = e.element.checked;
          } else {
            formData[container.querySelector('.mod-input__inner input').getAttribute('id')] = value;
          }
        }
      })
      .on('core.form.valid', () => {
        catalogueSubscribe(formData);
      });
  }
});
